import { useCallback, useState } from "react";
import { message } from "antd";

import NetworkApi from "../network/networkApi";

import { PLAN_STATUS } from "../enums/plan.enum";

export const usePlanDecline = (): [
  boolean,
  (id: string, fn: () => void) => void
] => {
  const [loading, changeLoading] = useState(false);

  const declinePlan = useCallback(async (id, fn: () => void) => {
    changeLoading(true);
    let response = await NetworkApi.requestPost("/api/plan/status/update", {
      id,
      status: PLAN_STATUS.DECLINED,
    });

    changeLoading(false);

    if (response.resultCode === 200) {
      message.success("Амжилттай цуцлагдлаа");
      if (fn) {
        fn();
      }
    } else {
      message.error(response.message || "Цуцлахад алдаа гарлаа.");
    }
  }, []);

  return [loading, declinePlan];
};
